"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1({ companyAddressForm, companyRegisterForm, closeDialog, }) {
    const { handleSubmit: handleCompanyAddressFormSubmit, setError: setCompanyAddressFormError } = companyAddressForm;
    const { setValue: setCompanyRegisterFormValue, clearErrors: clearCompanyRegisterFormErrors } = companyRegisterForm;
    const { t } = (0, react_i18next_1.useTranslation)();
    const onSaveCompanyAddressClick = handleCompanyAddressFormSubmit((addressFormValues) => {
        const { company_post_code, company_address, company_address_detail } = addressFormValues;
        if (!company_post_code) {
            setCompanyAddressFormError('root.noAddress', {
                type: 'required',
                message: t('"주소 찾기" 버튼을 눌러 주소를 입력해주세요!'),
            });
        }
        else {
            setCompanyRegisterFormValue('company_post_code', company_post_code, { shouldDirty: true });
            setCompanyRegisterFormValue('company_address', company_address, { shouldDirty: true });
            setCompanyRegisterFormValue('company_address_detail', company_address_detail, {
                shouldDirty: true,
            });
            clearCompanyRegisterFormErrors('company_post_code');
            closeDialog();
        }
    });
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "sticky-btn-bg", css: { position: 'sticky', bottom: 0, padding: '60px 16px 32px' } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ id: "company_address_save", onClick: onSaveCompanyAddressClick, sx: {
                width: '100%',
                height: '56px',
                borderRadius: '12px',
                color: 'var(--white)',
                bgcolor: 'var(--primary-main) !important',
            } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('저장') })) })) })));
}
exports.default = default_1;
